import React, { useState, useEffect} from 'react';
import Project from '../Project/Project';
import './Projects.css';



const Projects = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetch('/projects.json')
        .then(res => res.json())
        .then(data => setProjects(data))
       
    }, [])

    return (

         <section id="projects">
                <div className="container-projects mt-5">
                    {
                        projects.map(project => <Project
                            key={project._id}
                            project={project}


                        >
                       </Project>)
                    }
                </div>

            <footer className="sub-footer">
                <small>Frontend &copy; 2018 &#9877; DILRUBA BORNA</small>
                <br />
                <small>Dhaka, Bangladesh</small>
            </footer>
        </section>
    );
};

export default Projects;


            

                
                